import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, ApiService, PaginatedResponse } from '../api/api.service';

export interface OrderdirectPurchaseInvoice {
    id: number;
    od_bon_nr: string;
    od_inkfak_nr: string | null;
    od_invoer_dat: string | null;
    od_cred_nr: string | null;
    od_prijs_ink: string | null;
    od_tot_excl: number | null;
    od_tot_incl: number | null;
    od_cred_naam: string | null;
    od_inkfak_tav: string | null;
    od_inkfak_ref: string | null;
    afas_creditor_id: number | null;
    exception: string | null;
    execute_at: string | null;
    failed_at: string | null;
    data: any;
    afas_ornu: string | null;
    afas_liin: string | null;
    afas_balance: string | null;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}

export interface OrderdirectPurchaseInvoiceParams {
    per_page?: number;
    page?: number;
    status?: 'new' | 'pending' | 'completed' | 'failed';
    from_date?: string;
    to_date?: string;
    search?: string;
}

@Injectable({
    providedIn: 'root',
})
export class OrderdirectPurchaseInvoiceService {
    constructor(private apiService: ApiService) {}

    triggerSync() {
        return this.apiService.postCall$<ApiResponse<string>>('orderdirect-purchase-invoices/sync', {});
    }

    getInvoices(
        params?: OrderdirectPurchaseInvoiceParams
    ): Observable<ApiResponse<PaginatedResponse<OrderdirectPurchaseInvoice>>> {
        return this.apiService.getCallObs<ApiResponse<PaginatedResponse<OrderdirectPurchaseInvoice>>>(
            'orderdirect-purchase-invoices',
            params || {}
        );
    }

    getInvoiceById(id: number): Observable<ApiResponse<OrderdirectPurchaseInvoice>> {
        return this.apiService.getCallObs<ApiResponse<OrderdirectPurchaseInvoice>>(
            `orderdirect-purchase-invoices/${id}`
        );
    }

    sendToAfas(id: number): Observable<ApiResponse<any>> {
        return this.apiService.postCall$<ApiResponse<any>>(`orderdirect-purchase-invoices/send-to-afas/${id}`, {});
    }

    sendAllToAfas(params?: OrderdirectPurchaseInvoiceParams): Observable<ApiResponse<any>> {
        return this.apiService.postCall$<ApiResponse<any>>(
            'orderdirect-purchase-invoices/send-all-to-afas',
            params || {}
        );
    }

    resetStatus(id: number): Observable<ApiResponse<any>> {
        return this.apiService.postCall$<ApiResponse<any>>(`orderdirect-purchase-invoices/reset-status/${id}`, {});
    }
}
